import { type CbhFeatureFlag } from "@src/appV2/FeatureFlags";

import { type FacilityRoles } from "../types";

// eslint-disable-next-line no-restricted-syntax, @typescript-eslint/naming-convention
export enum ALERT_TYPE {
  EMAIL = "EMAIL",
  SMS = "SMS",
}

export interface FacilityNotificationAlertType {
  default: {
    enabled: boolean;
    batch: boolean;
    notifyRole?: string;
    userModifiableBatch: boolean;
    userModifiableState: boolean;
    tempBatchDisable?: boolean;
    time: number;
  };
  disableBatching?: boolean;
  type: ALERT_TYPE;
  title: string;
  action: string;
  role?: string;
  mandatoryRoles?: string[];
  mandatoryPermissions?: string[];
  validRoles?: string[];
  validPermissions?: string[];
  lddFlag?: string;
}

export type WorkplaceNotificationRoleAndAlerts = Record<
  string,
  {
    lddFlag?: CbhFeatureFlag;
    mandatoryRoles?: FacilityRoles[];
    alertTypes: FacilityNotificationAlertType[];
    type?: ALERT_TYPE;
  }
>;

export type WorkplaceNotificationsMap = Record<ALERT_TYPE, WorkplaceNotificationRoleAndAlerts>;

export interface FacilityNotification {
  action: string;
  alertTypes?: FacilityNotificationAlertType[];
  type: ALERT_TYPE;
  default: FacilityNotificationAlertType["default"];
  role?: string;
}

export interface IAlertSetting {
  userModifiableState: boolean;
  userModifiableBatch: boolean;
  time: number;
  enabled: boolean;
  batch: boolean;
  tempBatchDisable?: boolean;
  notifyRole?: string;
  default?: Omit<IAlertSetting, "default">;
}

export type TypeAlertSettings = Record<string, Record<string, IAlertSetting>>;

export type TypeNotify = Record<string, Record<string, boolean>>;

export interface INotification {
  description: string;
  email: string | boolean;
  sms: string | boolean;
  push: string | boolean;
  defaultValues?: Record<string, FacilityNotificationAlertType["default"]>;
  flag?: string;
  emailFlag?: string;
  smsFlag?: string;
}
